// import { makeStyles } from "@mui/styles";
import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  link: {
    textDecoration: "none",
    "&:hover, &:focus": {
      backgroundColor: theme.palette.background.light,
    },
  },
  linkActive: {
    backgroundColor: theme.palette.background.light,
  },
  linkNested: {
    paddingLeft: 0,
    "&:hover, &:focus": {
      backgroundColor: "#FFFFFF",
    },
  },
  linkIcon: {
    // marginRight: 8,
    color: theme.palette.text.secondary + "99",
    transition: theme.transitions.create("color"),
    minWidth: 24,
    display: "flex",
    justifyContent: "center",
  },
  linkIconActive: {
    color: theme.palette.primary.main,
  },
  linkText: {
    padding: 0,
    color: theme.palette.text.secondary + "CC",
    transition: theme.transitions.create(["opacity", "color"]),
    fontSize: 16,
  },
  linkTextActive: {
    color: theme.palette.text.primary,
  },
  linkTextHidden: {
    opacity: 0,
  },
  nestedList: {
    paddingLeft: 16 + 30,
  },
  sectionTitle: {
    marginLeft: 36,
    marginTop: 16,
    marginBottom: 16,
  },
  divider: {
    marginTop: 16,
    marginBottom: 32,
    height: 1,
    backgroundColor: "#D8D8D880",
  },
}));
